import { EuiSpacer } from '@elastic/eui';
import NetTable from 'components/Web_User_Interface/720p_Series/Network/IP_Configuration/netTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  NetTable,
  BreadCrumbs,
  SEOHelmet,
  React
};